import { Link } from 'react-router-dom';
import type { AuditEvent } from '@quds/shared';
import { formatDateTime, formatRelative } from '@/lib/format';
import { activityIcon, actorLabel } from './activityIcons';

export function ActivityItem({ event, showTarget = true }: { event: AuditEvent; showTarget?: boolean }) {
  const Icon = activityIcon(event.action);
  return (
    <li className="flex items-start gap-3 py-3">
      <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-surface-sunken text-ink-secondary">
        <Icon size={15} aria-hidden="true" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="flex flex-wrap items-center gap-2 text-sm text-ink">
          <span className="font-medium">{event.summary}</span>
        </p>
        <p className="mt-0.5 text-xs text-ink-secondary">
          {actorLabel(event)}
          {showTarget && event.business && (
            <>
              {' · '}
              <Link to={`/pharmacies/${event.business.id}`} className="font-medium text-primary hover:underline">
                {event.business.name}
              </Link>
            </>
          )}
        </p>
      </div>
      <time dateTime={event.occurredAt} title={formatDateTime(event.occurredAt)} className="shrink-0 text-xs text-ink-muted">
        {formatRelative(event.occurredAt)}
      </time>
    </li>
  );
}
